import { PaymentMethods } from '@/types/enum';
import * as yup from 'yup';
import { ICarrier, OpraStatus } from '@/types';
import { baseEntityFields, insuranceLiabilitySchema, addressSchema, agentInsurerFields, accountingContactFields, entityDetailsFields, optionaladdressSchema } from './CommonSchema';

// Base fields common to both carrier types (imported from CommonSchema)
const baseCarrierFields = baseEntityFields;

// Freight/Operations carrier specific fields
const freightCarrierFields = {
  usdot: yup.string().label('USDOT').when('withoutUsdot', {
    is: true,
    then: (schema) => schema.optional().nullable().optional(),
    otherwise: (schema) => schema.required('USDOT is required'),
  }),
  mcNumber: yup.string().label('MC Number').required('MC Number is required'),
  contactPersons: yup.array().default([]).notRequired(),
  alternatphone: yup.string().optional()
  // .test('is-valid-phone', 'Invalid Alternate Phone No number', (value) => {
  //     if (!value) return true;
  //     return validPhoneNumber(value);
  //   })
    .label('Alternate Contact').when('phone', {
      is: (value: string) => !value,
      then: (schema) => schema.required('Alternate Phone No is required'),
    }),
  extentionNo: yup.string().optional().label('Extension No'),
  rate: yup.number().label('Rate').required('Rate is required'),
  powerunit: yup.array().of(yup.string()).label('Power Unit').required('Power Unit is required'),
  trailer: yup.array().of(yup.string()).label('Trailer').required('Trailer is required'),
  ...agentInsurerFields,
  ...insuranceLiabilitySchema,
  ...entityDetailsFields,
  ...optionaladdressSchema
};

// Accounting vendor specific fields
const accountingVendorFields = {
  ...accountingContactFields,
  ...addressSchema,
  rating: yup.string().optional(),
};

// Freight/Operations carrier schema
const carrierFormSchema = yup.object().shape({
  ...baseCarrierFields,
  ...freightCarrierFields,
});

// Accounting vendor schema
const vendorFormSchema = yup.object().shape({
  ...baseCarrierFields,
  ...accountingVendorFields,
});

// Default data for freight/operations carrier
const defaultCarrierData: ICarrier = {
  company: '',
  email: '',
  insuranceDocuments: [],
  deleteInsuranceFiles: [],
  powerunit: [],
  trailer: [],
  extentionNo: '',
  mcNumber: '',
  usdot: '',
  alternatphone: '',
  address: '',
  rate: 0,
  autoScore: 100,
  stars: 5,
  phone: '',
  paymentMethod: PaymentMethods.NA,
  paymentTerms: '',
  documents: [],
  deleteFiles: [],
  entityDetails: {
    entity_type: '',
    dba_name: '',
    legal_name: '',
    operating_status: '' as OpraStatus,
    physical_address: '',
    mailing_address: '',
    carrier_operation: [],
    out_of_service_date: '',
  },
  withoutUsdot: false,
  insurerCompany: '',
  agentName: '',
  agentAddress: '',
  agentEmail: '',
  agentPhoneNumber: '',
  commercialGeneralLiability: undefined,
  automobileLiability: undefined,
  cargoLiability: undefined,
};

// Default data for accounting vendor
const defaultVendorData: ICarrier = {
  company: '',
  email: '',
  insuranceDocuments: [],
  deleteInsuranceFiles: [],
  powerunit: [],
  trailer: [],
  extentionNo: '',
  mcNumber: '',
  usdot: '',
  alternatphone: '',
  address: '',
  rate: 0,
  autoScore: 100,
  stars: 5,
  phone: '',
  mobileNo: '',
  fax: '',
  other: '',
  website: '',
  notes: '',
  rating: '',
  billingAddress: {
    address: '',
    city: '',
    state: '',
    zipCode: '',
    country: ''
  },
  shippingAddress: {
    address: '',
    city: '',
    state: '',
    zipCode: '',
    country: ''
  },
  sameAsBillingAddress: false,
  nameToPrintOnCheck: '',
  displayCustomerName: '',
  paymentMethod: PaymentMethods.NA,
  paymentTerms: '',
  isSubVendor: false,
  parentVendor: undefined,
  documents: [],
  deleteFiles: [],
};

export { carrierFormSchema, vendorFormSchema };
export { defaultCarrierData, defaultVendorData };
